import {useEffect, useState} from "react";
import {Modal, ModalBody, ThemeProvider} from "react-bootstrap";
import { Nav, Navbar, Container} from "react-bootstrap";
import {Route, Routes, Link, Outlet, useNavigate, useLocation} from "react-router-dom"; // הוספת React Router
import "bootstrap/dist/css/bootstrap.rtl.min.css"; // תמיכה ב-RTL
import "bootstrap/dist/js/bootstrap.bundle.min"; // טעינת JavaScript של Bootstrap
import 'bootstrap-icons/font/bootstrap-icons.css';
import HomePage from "./HomePage.js"
import DashboardPage from "./Dashboard";
import AssetsPage from "./AssetsPage";
import ContactPage from "./Contact"
import SimulatorPage from './SimulatorPage';
import LoginPage from './LoginPage';
import AboutPage from "./AboutPage";
import NotFound from "./PageNotFound";
import AccountPage from "./AccountPage";
import ConsultantSidebar from "./ConsultantsSidebar";


// Shared layout for the logged-in "app" pages: renders the navigation sidebar ONCE and swaps
// only the page content via <Outlet/>, so the sidebar stays mounted (no flicker) between routes.
// The sidebar is only shown when logged in -- logged-out visitors see the demo/login views.
function SidebarLayout({user}) {
  return (
    <>
      {user.id !== null && <ConsultantSidebar/>}
      <Outlet/>
    </>
  );
}





const NAV_LINKS = [
  {to: "/simulator", label: "דשבורד", icon: "bi-sliders", cta: true, authOnly: true},
  {to: "/about", label: "אודות", icon: "bi-info-circle"},
  {to: "/contact", label: "צור קשר", icon: "bi-envelope"},
];

function App() {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(() => {
    const savedToken = localStorage.getItem("token");
    return savedToken ? { name: localStorage.getItem("username"), id: localStorage.getItem("userid") } : { name: "anonimouse", id: null };
  });

  useEffect(() => {
    document.documentElement.setAttribute("dir", "rtl");
    document.documentElement.setAttribute("lang", "he");
  }, []);
  const [login, setLogin] = useState(localStorage.getItem("username") ? "התנתק" :"התחבר");



  const LogOut = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("userid");
    localStorage.removeItem("username");
    sessionStorage.removeItem("homepage-reloaded");
    setLogin("התחבר");
    setUser({name:"anonimouse", id: null});
    navigate("/home");
  };
  const [showalbert, setAlbert] = useState(false);
  const [msg, setMsg] = useState("");
  const showMessage = (message) => {
    console.log(message);
    setMsg(message);
    setAlbert(true);
  };

  return (
      <div>
        <ThemeProvider>
          <Navbar expand="lg" variant="dark" fixed="top" className="app-navbar">
            <Container>
              <Navbar.Brand as={Link} to="/" className="app-navbar-brand">
                <i className="bi bi-houses"></i>
                משכנתא דאטה
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav"/>
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="me-auto app-nav-links">
                  {NAV_LINKS.filter(link => !link.authOnly || user.id !== null).map(link => (
                      <Nav.Link
                          key={link.to}
                          as={Link}
                          to={link.to}
                          className={[link.cta ? "app-nav-cta" : "", location.pathname === link.to ? "active" : ""].filter(Boolean).join(" ")}
                      >
                        <i className={`bi ${link.icon}`}></i> {link.label}
                      </Nav.Link>
                  ))}
                </Nav>

                <div className="app-navbar-user">
                  <Link to="/account" className="app-navbar-username">
                    <i className="bi bi-person-circle"></i> {user.name}
                  </Link>
                  <button className="app-navbar-auth" onClick={() => {
                    user.id === null ?  navigate("/login") : LogOut()
                  }}>
                    <i className={`bi ${user.id === null ? "bi-box-arrow-in-left" : "bi-box-arrow-left"}`}></i>
                    {login}
                  </button>
                </div>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        <Modal show={showalbert} style={{padding: '10px', zIndex: 16001}} >
            <Modal.Title>  הודעה  </Modal.Title>
            <ModalBody> {msg} </ModalBody>
          <Modal.Footer><button className="abort" onClick={() => {setAlbert(false)}}> סגור </button></Modal.Footer>
        </Modal>
          {/* Routes עבור כל הדפים */}
          <Routes>
            <Route path="/" element={<HomePage albert={showMessage}/>}/>
            <Route path="/home" element={<HomePage  albert={showMessage}/>}/>
            <Route element={<SidebarLayout user={user}/>}>
              <Route path="/simulator" element={<SimulatorPage user={user} albert={showMessage} />}/>
              <Route path="/assets" element={<AssetsPage user={user} albert={showMessage} />}/>
              <Route path="/dashboard" element={<DashboardPage user={user} albert={showMessage} />}/>
              <Route path="/account" element={<AccountPage user={user} albert={showMessage}/>}/>
            </Route>
            <Route path="/contact" element={<ContactPage albert={showMessage}/>}/>
            <Route path="/login" element={<LoginPage setLogin={setLogin} setUser={setUser} albert={showMessage}/>}/>
            <Route path="/about" element={<AboutPage albert={showMessage}/>}/>
            {/*<Route path="/colsultant"  element={<ConsultantPage albert={showMessage}/>} />*/}
            {/*<Route path="/profile" element={<ConsultantProfile user={user} albert={showMessage}/>} />*/}
            {/*<Route path="/leads"  element={<ConsultantPage albert={showMessage}/>} />*/}
            {/*<Route path="/crm"  element={<ConsultantPage albert={showMessage} />} />*/}
            <Route path="*" element={<NotFound />}/>
          </Routes>

        </ThemeProvider>
      </div>
  );
}

export default App;
